import React from 'react'
import { useTranslation } from 'react-i18next'
import { DepartmentListItemProps } from 'types/common'
import { Button, ButtonBase } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import type { Theme } from '@mui/material'
import { Text1 } from 'ui/shorthands/Texts'
import { QuestionTooltipWithLabel } from 'ui/shorthands/QuestionTooltip'
import SortableMenu from 'ui/utils/SortableMenu'

const useStyles = makeStyles()((theme: Theme) => ({
  generalMenuButton: {
    display: 'block',
    width: '100%',
    textAlign: 'left',
    padding: theme.spacing(1.5, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  subHeader: {
    padding: theme.spacing(6.25, 2, 1, 2),
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  current: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,
  },
  listContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflowY: 'auto',
    paddingBottom: 76, //NOTE: wovnタグで必要な高さ
  },
  empty: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
  },
}))

export type SettingsSubmenuProps = {
  generalMenu: {
    onClick?: () => void
    current: boolean
  }
  department?: {
    onCreate: () => void //TODO: department.listにunshift
    list: Array<DepartmentListItemProps>
    currentId?: number
    onSelect: (departmentId: number) => void
    onChange: (id: number, order: number) => void
  }
}

const SettingSubmenu: React.FC<SettingsSubmenuProps> = ({
  generalMenu,
  department,
}: SettingsSubmenuProps) => {
  const { t } = useTranslation()
  const { classes, cx } = useStyles()

  return (
    <>
      <ButtonBase
        onClick={generalMenu.onClick}
        className={cx(
          classes.generalMenuButton,
          generalMenu.current && classes.current
        )}
      >
        <Text1 className={cx(generalMenu.current && classes.current)}>
          {t('一般')}
        </Text1>
      </ButtonBase>
      {department && (
        <>
          <div className={classes.subHeader}>
            <QuestionTooltipWithLabel label={t('受付科目')}>
              {t('受付科目はドラッグ&ドロップで並べ替えることができます。')}
            </QuestionTooltipWithLabel>
            <Button
              variant={'contained'}
              color={'primary'}
              onClick={department.onCreate}
            >
              {t('新規作成')}
            </Button>
          </div>
          {department.list.length > 0 ? (
            <div className={classes.listContainer}>
              <SortableMenu
                onSelect={department.onSelect}
                list={department.list}
                onChange={department.onChange}
                currentId={department.currentId}
              />
            </div>
          ) : (
            <div className={classes.empty}>
              <Text1>
                {t('受付科目がありません')}
                <br />
                {t('新規作成してください')}
              </Text1>
            </div>
          )}
        </>
      )}
    </>
  )
}

export default SettingSubmenu
